//Libs
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

/**
 * Retorna um componente customizado para rótulo do item do eixo X
 * @param {Object} props Propriedades do Componentes
 * @param {*} props.x Coordenada x do label
 * @param {*} props.y Coordenada y do label
 * @param {Object} props.payload Objeto contendo os dados para exibição no gráfico
 */
function CustomizedAxisTick({x, y, payload}) {
    const theme = useTheme();
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="end" fill={theme.palette.text.secondary} transform="rotate(-35)">{payload.value}</text>
        </g>
    );
}

//Definição das propriedades do componente
CustomizedAxisTick.propTypes = {
    x: PropTypes.any,
    y: PropTypes.any,
    payload: PropTypes.shape({
        value: PropTypes.string
    })
};

export default CustomizedAxisTick;